import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { TextButtonComponent } from '../../../../../shared/src/lib/components/text-button/text-button.component';
import { Angulartics2OnModule } from 'angulartics2';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-manual-override-box',
    templateUrl: './manual-override-box.component.html',
    styleUrls: ['./manual-override-box.component.scss'],
    imports: [TextButtonComponent, Angulartics2OnModule, TranslateModule]
})
export class ManualOverrideBoxComponent {
  @Input()
  overridden: boolean;

  @Output() override = new EventEmitter<boolean>();

  public toggleManualOverride() {
    this.override.emit(this.overridden);
  }

}
